import { IconWrapper, NoteText, Wrapper } from './InfoNote.styles';
import type { InfoNoteProps } from './InfoNote.types';

export function InfoNote({ text, icon, variant = 'info' }: InfoNoteProps) {
  return (
    <Wrapper>
      {icon && <IconWrapper $variant={variant}>{icon}</IconWrapper>}
      <NoteText $variant={variant}>{text}</NoteText>
    </Wrapper>
  );
}
